import * as yup from 'yup';

export const TimeosUserSchema = yup.object({
  id: yup.number().notRequired().nullable(),
  username: yup.string().notRequired().nullable(),
  isSynchronized: yup.boolean().notRequired().nullable(),
});

export interface ITimeosUser {
  id?: number;
  username?: string;
  isSynchronized?: boolean;
}
